export const APPLICATION_WRP_ID = 'applicationWrp';
